// extracted by mini-css-extract-plugin
export default {"host":"MediaFilterTags_host__9Tjiz","tags":"MediaFilterTags_tags__V1adw"};